import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Dropdown, Form, Row } from 'react-bootstrap'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisVertical, faPlus, faPencil, faTrash, faList } from '@fortawesome/free-solid-svg-icons'
import toast from 'react-hot-toast'
import { ExamCategoryService } from '../../services/examCategory.service'
import AddCategoryModal from '../../Modal/AddExamCategory.modal'
import CustomToggle from '../../Menu/CustomMenu'
import EditCategoryModal from '../../Modal/EditExamCategory.modal'

// Accent palette cycled across list cards — presentation only.
const CARD_ACCENTS = ["#2563eb", "#0891b2", "#16a34a", "#d97706", "#7c3aed", "#db2777", "#14b8a6", "#ea580c"];

export default function ExamCategory() {

    const [showCategoryModal, setShowCategoryModal] = useState<boolean>(false)
    const [showEditCategoryModal, setShowEditCategoryModal] = useState<number>(-1)
    const [categoriesData, setCategoriesData] = useState<any>();

    const getAllExamCategories = async () => {
        await ExamCategoryService.getAllCompanyExamCategories().then((res) => {
            if (res.status === 200) {
                setCategoriesData(res.data.examCategories)
            }
        })
    }

    const handleDeleteExamCategory = async (id: any) => {
        await ExamCategoryService.deleteExamCategory(id).then((res) => {
            if (res.status === 200) {
                getAllExamCategories();
                toast.success("Deleted")
            }
        }).catch(err => {
            toast.error(err.response.data)
        })
    }

    useEffect(() => {
        getAllExamCategories()
    }, [])

    return (
        <>
            <div>
                <div className="ds-page-head">
                    <div className="ds-page-head__text">
                        <h1 className="ds-page-head__title">Exam Categories</h1>
                        <p className="ds-page-head__sub">
                            {categoriesData?.length || 0} {categoriesData?.length === 1 ? "category" : "categories"} configured for your question bank
                        </p>
                    </div>
                    <div className="ds-page-head__actions">
                        <Button onClick={() => setShowCategoryModal(true)}>
                            <FontAwesomeIcon icon={faPlus} className="me-2" />Add Category
                        </Button>
                    </div>
                </div>

                <div className="tw-grid tw-gap-3 tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-3">
                    {categoriesData && categoriesData.length > 0 ? categoriesData.map((data: any, index: number) => {
                        const accent = CARD_ACCENTS[index % CARD_ACCENTS.length];
                        return (
                            <Card key={data._id || index} className="ds-card-hover">
                                <Card.Body>
                                    <div className="d-flex align-items-start justify-content-between">
                                        <div className="d-flex align-items-center" style={{ gap: 12, minWidth: 0 }}>
                                            <span className="ds-row-chip" style={{ background: `${accent}14`, color: accent }}>
                                                {String(data.name || "?").charAt(0).toUpperCase()}
                                            </span>
                                            <div style={{ minWidth: 0 }}>
                                                <div style={{ fontSize: 15, fontWeight: 700, color: "var(--ds-text)" }} className="text-truncate">{data.name}</div>
                                                <div style={{ fontSize: 12, color: "var(--ds-text-faint)" }}>
                                                    Created {moment(data.createdAt).format("DD MMM YYYY")}
                                                </div>
                                            </div>
                                        </div>
                                        <Dropdown>
                                            <Dropdown.Toggle as={CustomToggle} id="dropxdown-custom-components">
                                                <FontAwesomeIcon icon={faEllipsisVertical} className="text-secondary xcn-link-pointer" />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu align="end">
                                                <Dropdown.Item onClick={() => setShowEditCategoryModal(index)}>
                                                    <FontAwesomeIcon icon={faPencil} className="me-2 text-secondary" />Edit
                                                </Dropdown.Item>
                                                <Dropdown.Item onClick={() => handleDeleteExamCategory(data._id)}>
                                                    <FontAwesomeIcon icon={faTrash} className="me-2 text-danger" />Delete
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between" style={{ marginTop: 16, paddingTop: 14, borderTop: "1px solid #f1f5f9" }}>
                                        <span style={{ fontSize: 13, color: "var(--ds-text-muted)", fontWeight: 500 }}>Allowed</span>
                                        <Form.Switch checked={data.allowed} readOnly />
                                    </div>
                                </Card.Body>
                            </Card>
                        )
                    }) : (
                        <Card style={{ gridColumn: "1 / -1" }}>
                            <Card.Body>
                                <div className="ds-empty">
                                    <span className="ds-empty__icon"><FontAwesomeIcon icon={faList} /></span>
                                    <div className="ds-empty__title">No exam categories yet</div>
                                    <div className="ds-empty__sub">Create your first exam category to start organising questions by exam.</div>
                                    <Button onClick={() => setShowCategoryModal(true)}>
                                        <FontAwesomeIcon icon={faPlus} className="me-2" />Add Category
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    )}
                </div>
            </div>

            <AddCategoryModal
                show={showCategoryModal}
                handleClose={() => { setShowCategoryModal(false); getAllExamCategories() }}
            />

            <EditCategoryModal
                show={showEditCategoryModal >= 0 ? true : false}
                handleClose={() => { setShowEditCategoryModal(-1); getAllExamCategories() }}
                categoryData={categoriesData && categoriesData[showEditCategoryModal]}
            />
        </>
    )
}
